import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CommunicationsService } from 'src/app/modules/communications/communications.service';
import { CompaniesService } from 'src/app/modules/companies/companies.service';
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { User } from 'src/app/shared/models/user/user.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ChooseRecipientDialogComponent } from '../choose-recipient-dialog/choose-recipient-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
var AddCommunicationDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AddCommunicationDialogComponent(dialogRef, chooseRecipientsDialog, data, confirmDialog, configService, cookieService, toastrService, translateService, communicationsService, authService, helperService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    companiesService, propertiesService) {
        this.dialogRef = dialogRef;
        this.chooseRecipientsDialog = chooseRecipientsDialog;
        this.data = data;
        this.confirmDialog = confirmDialog;
        this.configService = configService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.communicationsService = communicationsService;
        this.authService = authService;
        this.helperService = helperService;
        this.apiService = apiService;
        this.companiesService = companiesService;
        this.propertiesService = propertiesService;
        this.subscriptions = [];
        this.loggedUser = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.showBcc = false;
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        this.attachmentBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.attach'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'accent',
            spinnerColor: 'accent',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paperclip',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        this.previousValue = {};
        this.phonebook = [];
        this.isMaster = false;
        this.isAdmin = false;
        this.companyData = {};
        // filteredRecipients = [];
        this.propertiesMaster = [];
    }
    /**
     * Init component
     *
     */
    AddCommunicationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser.setData(res); }));
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "admin"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "operator") {
            this.isAdmin = true;
        }
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "master"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "collaborator") {
            this.isMaster = true;
            this.subscriptions.push(this.propertiesService.getPropertiesMaster().subscribe(function (res) {
                if (res.status) {
                    _this.propertiesMaster = res.data.items;
                }
            }, function (err) {
            }));
            this.currentRole = this.loggedUser.get("userRoles").find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            if (this.currentRole.company._id !== "") {
                this.subscriptions.push(this.companiesService.get(this.currentRole.company._id).subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                    }
                }));
            }
        }
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Set company
        this.companyId = this.cookieService.get("requestedCompany");
        // Get form initial values and init the form
        this.getDataAndInitForm();
        // Stop loading dialog
        setTimeout(function () {
            _this.dialogIsLoading = false;
        }, 500);
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Preload data and then init form. If something
     * goes wrong just init the form
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.getDataAndInitForm = function () {
        var _this = this;
        // let recipientEmails;
        if (this.data) {
            // if (this.data.recipients) {
            //   recipientEmails = this.data.recipients.map((obj: any) => obj.email);
            // }
            if (this.data.body) {
                this.injectedBody = this.data.body;
            }
            if (this.data.subject) {
                this.injectedSubject = this.data.subject;
            }
            // Get available recipients from phonebook
            if (this.isAdmin) {
                this.loadFullPhonebook(function (limit) { return _this.companiesService.getPhonebookListAdmin(0, limit, null, "asc"); });
            }
            else if (this.isMaster) {
                if (this.data.phonebook && Array.isArray(this.data.phonebook) && this.data.phonebook.length) {
                    this.phonebook = this.data.phonebook;
                    this.initForm();
                }
                else {
                    this.loadFullPhonebook(function (limit) { return _this.companiesService.getPhonebookList(_this.companyId, 0, limit, null, "asc"); });
                }
            }
        }
    };
    /**
     * Load the whole phonebook into the recipient picker.
     *
     * The list endpoint is paginated: when called without an explicit `limit` it
     * only returns the backend default page (e.g. ~10 items). We read `totalCount`
     * from that first page and, when the list turns out to be truncated, we
     * re-fetch using `totalCount` as the limit, so the picker always shows every
     * contact regardless of how many there are (no hard-coded page-size guess).
     *
     * @param fetchPage function performing the list call for a given `limit`
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.loadFullPhonebook = function (fetchPage) {
        var _this = this;
        this.subscriptions.push(fetchPage(null).subscribe(function (res) {
            if (!res || !res.status) {
                return;
            }
            var items = res.data && res.data.items ? res.data.items : [];
            var total = res.data && res.data.totalCount ? res.data.totalCount : 0;
            if (items.length >= total) {
                _this.phonebook = items;
                _this.initForm();
                return;
            }
            // First page was truncated by the backend default page size: re-fetch
            // the full list using the known totalCount as the limit.
            _this.subscriptions.push(fetchPage(total).subscribe(function (fullRes) {
                _this.phonebook = fullRes && fullRes.status && fullRes.data && fullRes.data.items
                    ? fullRes.data.items
                    : items;
                _this.initForm();
            }, function (err) {
                // Fall back to the first (partial) page so the picker stays usable.
                _this.phonebook = items;
                _this.initForm();
                _this.helperService.handleError(err);
            }));
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.initForm = function () {
        var _this = this;
        // If we have pre-filled recipients, add it to model
        if (this.data.recipients) {
            this.model = tslib_1.__assign({}, this.model, { recipients: this.data.recipients.map(function (obj) { return obj.email; }) });
        }
        // Minimum char amount to activate search filtering
        var minTermLength = 1;
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        key: 'sender',
                        hide: true,
                        templateOptions: {
                            value: this.loggedUser.get("email"),
                        },
                    },
                    {
                        className: 'col-11 mb-0 autocomplete-multi-email',
                        type: 'autocomplete',
                        key: 'recipients',
                        templateOptions: {
                            customLabel: this.translateService.instant('communications.fields.recipients'),
                            required: true,
                            bindLabel: 'email',
                            bindValue: 'email',
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant('common.words.clearAll'),
                            notFoundText: this.translateService.instant('common.words.notFound'),
                            addTagText: this.translateService.instant('common.words.addTag'),
                            loadingText: this.translateService.instant('common.words.loading'),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipients;
                            }
                        }
                    },
                    {
                        className: 'col-1 mb-0',
                        type: 'button',
                        key: 'openPhonebook',
                        templateOptions: {
                            color: 'accent',
                            tooltip: 'tooltip',
                            icon: {
                                fontSet: 'fas',
                                fontIcon: 'fa-book-user'
                            },
                            onClick: function ($event) { return _this.onChooseRecipientDialogOpen('recipients'); },
                        },
                    },
                    // {
                    //   className: 'col-12 mb-0',
                    //   type: 'select',
                    //   key: 'recipients2',
                    //   hideExpression: (model): boolean => model.chooseRecipient === 'selected',
                    //   templateOptions: {
                    //     label: this.translateService.instant('communications.fields.recipients'),
                    //     disabled: true,
                    //     options: []
                    //   },
                    //   expressionProperties: {
                    //     "templateOptions.options": () => {
                    //       return [
                    //         {
                    //           value: 'occupant',
                    //           label: this.translateService.instant(`communications.fields.occupant`, { value: this.filteredRecipients.length }),
                    //         },
                    //         {
                    //           value: 'councilor',
                    //           label: this.translateService.instant(`communications.fields.councilor`, { value: this.filteredRecipients.length }),
                    //         }
                    //       ]
                    //     }
                    //   }
                    // },
                    // {
                    //   className: 'col-12 col-sm-2 text-muted toggle-field',
                    //   type: 'checkbox',
                    //   key: 'showCc',
                    //   defaultValue: false,
                    //   templateOptions: {
                    //     label: this.translateService.instant('communications.fields.showCc'),
                    //   },
                    // },
                    // {
                    //   className: 'col-12 col-sm-2 text-muted toggle-field',
                    //   type: 'checkbox',
                    //   key: 'showBcc',
                    //   defaultValue: false,
                    //   templateOptions: {
                    //     label: this.translateService.instant('communications.fields.showBcc'),
                    //   },
                    // },
                    // {
                    //   className: 'col-12 col-sm-8 text-muted radio-wrapper',
                    //   type: 'radio',
                    //   key: 'chooseRecipient',
                    //   defaultValue: 'selected',
                    //   expressionProperties: {
                    //     "templateOptions.onChange": (model: any) => {
                    //       this.onChooseRecipientChanged(model.chooseRecipient);
                    //     },
                    //   },
                    //   templateOptions: {
                    //     options: [
                    //       {
                    //         value: "selected",
                    //         label: this.translateService.instant('communications.fields.sendToSelected'),
                    //       },
                    //       {
                    //         value: "occupant",
                    //         label: this.translateService.instant('communications.fields.sendToOccupants'),
                    //       },
                    //       {
                    //         value: "councilor",
                    //         label: this.translateService.instant('communications.fields.sendToCouncilors'),
                    //       }
                    //     ]
                    //   },
                    // },
                    {
                        className: 'col-11 mb-0 autocomplete-multi-email',
                        type: 'autocomplete',
                        key: 'recipientsCc',
                        // hideExpression: (model): boolean => !model.showCc,
                        templateOptions: {
                            customLabel: this.translateService.instant('communications.fields.recipientsCc'),
                            required: false,
                            bindLabel: 'email',
                            bindValue: 'email',
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant('common.words.clearAll'),
                            notFoundText: this.translateService.instant('common.words.notFound'),
                            addTagText: this.translateService.instant('common.words.addTag'),
                            loadingText: this.translateService.instant('common.words.loading'),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipientsCc;
                            }
                        }
                    },
                    {
                        className: 'col-1 mb-0',
                        type: 'button',
                        key: 'openPhonebook',
                        templateOptions: {
                            color: 'accent',
                            tooltip: 'tooltip',
                            icon: {
                                fontSet: 'fas',
                                fontIcon: 'fa-book-user'
                            },
                            onClick: function ($event) { return _this.onChooseRecipientDialogOpen('recipientsCc'); },
                        },
                    },
                    {
                        className: 'col-11 mb-0 autocomplete-multi-email',
                        type: 'autocomplete',
                        key: 'recipientsBcc',
                        templateOptions: {
                            customLabel: this.translateService.instant('communications.fields.recipientsBcc'),
                            required: false,
                            bindLabel: 'email',
                            bindValue: 'email',
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant('common.words.clearAll'),
                            notFoundText: this.translateService.instant('common.words.notFound'),
                            addTagText: this.translateService.instant('common.words.addTag'),
                            loadingText: this.translateService.instant('common.words.loading'),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipientsBcc;
                            }
                        }
                    },
                    {
                        className: 'col-1 mb-0',
                        type: 'button',
                        key: 'openPhonebook',
                        templateOptions: {
                            color: 'accent',
                            tooltip: 'tooltip',
                            icon: {
                                fontSet: 'fas',
                                fontIcon: 'fa-book-user'
                            },
                            onClick: function ($event) { return _this.onChooseRecipientDialogOpen('recipientsBcc'); },
                        },
                    },
                    {
                        className: 'col-12 mb-0',
                        template: '<hr>',
                    },
                    {
                        className: 'col-12 pt-2 mb-1',
                        type: 'input',
                        key: 'subject',
                        templateOptions: {
                            label: this.translateService.instant('communications.fields.subject'),
                            placeholder: this.translateService.instant('communications.fields.subject'),
                            required: false,
                            minLength: 1,
                            maxLength: 1000,
                        },
                        hooks: {
                            onInit: function (field) {
                                if (_this.injectedSubject) {
                                    field.formControl.setValue(_this.injectedSubject);
                                }
                            }
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'textarea',
                        key: 'body',
                        templateOptions: {
                            label: this.translateService.instant('communications.fields.body'),
                            placeholder: this.translateService.instant('communications.fields.body'),
                            required: true,
                            maxLength: 5000,
                            rows: 6,
                        },
                        hooks: {
                            onInit: function (field) {
                                if (_this.injectedBody) {
                                    field.formControl.setValue(_this.injectedBody);
                                }
                            }
                        },
                    },
                    {
                        className: "col-6 mb-0",
                        type: "file-uploader",
                        key: "attachments",
                        templateOptions: {
                            required: false,
                            allowedFilesNumber: 999999,
                            allowedMBNumber: 100,
                            customLabel: this.translateService.instant('communications.fields.attachments'),
                        }
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.onClose = function (data) {
        var _this = this;
        // @todo: copiare negli altri dialog che rischiano perdita di dati
        // Prevent unsaved data loss
        if (this.form.dirty && !this.form.pristine) {
            var confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: '50%',
                maxHeight: '98vh',
                data: {
                    title: this.translateService.instant('common.warnings.warning'),
                    message: this.translateService.instant('common.warnings.unsavedData'),
                    btnOkText: this.translateService.instant('common.cta.continue'),
                    btnCancelText: this.translateService.instant('common.cta.undo'),
                },
                disableClose: true,
            });
            // Subscribe to dialog result (only for 1 emit thanks to "take()")
            confirmDialogRef.beforeClosed()
                .pipe(take(1))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                _this.dialogRef.close();
                return;
            });
        }
        else {
            this.dialogRef.close();
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        var confirmDialogRef;
        // Email subject is not mandatory, but if it's empty we open a confirm dialog
        // to inform user that there's no subject in mail
        if (!this.form.controls['subject'].value) {
            confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: '50%',
                maxHeight: '98vh',
                data: {
                    title: this.translateService.instant('dialogs.confirm.title'),
                    message: this.translateService.instant('communications.add.noSubjectDialog.message'),
                    btnOkText: this.translateService.instant('communications.add.noSubjectDialog.confirm'),
                    btnOkIcon: 'fa-paper-plane',
                    btnCancelText: this.translateService.instant('common.cta.undo'),
                    btnCancelIcon: 'fa-times-circle',
                }
            });
        }
        else {
            // Open confirm dialog before sending email
            confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: '50%',
                maxHeight: '98vh',
                data: {
                    title: this.translateService.instant('dialogs.confirm.title'),
                    message: this.translateService.instant('communications.add.confirmMessage'),
                    btnOkText: this.translateService.instant('common.cta.send'),
                    btnOkIcon: 'fa-paper-plane',
                    btnCancelText: this.translateService.instant('common.cta.undo'),
                    btnCancelIcon: 'fa-times-circle',
                }
            });
        }
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        confirmDialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // Back to main dialog
                return;
            }
            // User has confirmed, we can send mails
            _this.dialogIsLoading = true;
            _this.createCommunication();
        });
    };
    /**
     * Create a new communication and send it
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.createCommunication = function () {
        var _this = this;
        // If message has no subject, let's put a default one before sending
        if (this.model && !this.model.subject) {
            this.model.subject = this.translateService.instant('communications.add.defaultSubject');
        }
        // delete this.model.showCc;
        // delete this.model.showBcc;
        // let recipients: any[];
        // if (this.model.chooseRecipient && this.model.chooseRecipient !== 'selected') {
        //   recipients = this.filteredRecipients;
        // } else {
        //   recipients = this.model.recipients as Array<string>;
        // }
        var attachments = this.model.attachments;
        if (typeof this.data.sendSharedUser !== "undefined" &&
            this.data.sendSharedUser) {
            if (attachments && Array.isArray(attachments)) {
                attachments.push({
                    originalName: "Guida-per-accedere-al-Fascicolo-del-Fabbricato-digitale-del-Condominio.pdf",
                    path: this.configService.apiHost + "/uploads/Guida-per-accedere-al-Fascicolo-del-Fabbricato-digitale-del-Condominio.pdf",
                    mimetype: "application/pdf",
                    size: 2903091,
                    createdAt: moment().toDate(),
                    updatedAt: moment().toDate(),
                });
            }
            else {
                attachments = [{
                        originalName: "Guida-per-accedere-al-Fascicolo-del-Fabbricato-digitale-del-Condominio.pdf",
                        path: this.configService.apiHost + "/uploads/Guida-per-accedere-al-Fascicolo-del-Fabbricato-digitale-del-Condominio.pdf",
                        mimetype: "application/pdf",
                        size: 2903091,
                        createdAt: moment().toDate(),
                        updatedAt: moment().toDate(),
                    }];
            }
        }
        var newCommunication = {
            recipients: this.model.recipients,
            recipientsCc: null,
            recipientsBcc: null,
            attachments: attachments,
            subject: this.model.subject,
            sendSharedUser: (typeof this.data.sendSharedUser !== "undefined") ? this.data.sendSharedUser : false,
            body: this.model.body,
            companyData: this.isMaster ? this.companyData : "",
            qrImage: this.data.qrImage,
            sendDocs: this.data.sendDocs ? true : false,
            sendByPec: this.data.sendByPec ? true : false,
        };
        if (Array.isArray(this.model.recipientsCc) && this.model.recipientsCc.length) {
            newCommunication = tslib_1.__assign({}, newCommunication, { recipientsCc: this.model.recipientsCc });
        }
        else {
            delete newCommunication.recipientsCc;
        }
        if (Array.isArray(this.model.recipientsBcc) && this.model.recipientsBcc.length) {
            newCommunication = tslib_1.__assign({}, newCommunication, { recipientsBcc: this.model.recipientsBcc });
        }
        else {
            delete newCommunication.recipientsBcc;
        }
        this.subscriptions.push(this.communicationsService.create(newCommunication)
            .pipe(finalize(function () {
            _this.formBtnOptions.active = false;
            _this.dialogIsLoading = false;
        }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.communicationsService.onCommunicationCreated();
                _this.dialogRef.close();
                return;
            }
            _this.toastrService.error(_this.translateService.instant('common.errors.unknown'));
        }, function (err) {
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Filter recipients users by type (from phonebook)
     *
     * @since 1.0.0
     */
    // filterRecipients(type?: string): void {
    //   if (!type) {
    //     return;
    //   }
    //   if (this.phonebook) {
    //     this.filteredRecipients = this.phonebook.filter(contact => contact.type === type);
    //   }
    // }
    /**
     * Update recipients basing on radio buttons changes
     *
     * @since 1.0.0
     */
    // onChooseRecipientChanged(value: string): void {
    //   if (value !== this.previousValue) {
    //     this.previousValue = value;
    //     // Update recipients array
    //     this.filterRecipients(value);
    //     // Update recipients field
    //     const recipientsControl = this.form.controls.recipients2;
    //     if (recipientsControl) {
    //       recipientsControl.setValue(value);
    //     }
    //   }
    //   return;
    // }
    /**
     * Update recipients basing on radio buttons changes
     *
     * @since 1.0.0
     */
    AddCommunicationDialogComponent.prototype.onChooseRecipientDialogOpen = function (key) {
        var _this = this;
        if (!key
            || (!this.phonebook)
            || (!this.phonebook.length)) {
            this.toastrService.error(this.translateService.instant('common.words.display_no_data'));
            return;
        }
        // Open dialog
        var dialogRef = this.chooseRecipientsDialog.open(ChooseRecipientDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                phonebook: this.phonebook,
                model: this.model[key],
                isMaster: this.isMaster,
                propertiesMaster: this.propertiesMaster,
            },
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed()
            .subscribe(function (res) {
            var _a;
            if (res) {
                var phonebookEmails_1 = _this.phonebook.map(function (contact) { return contact.email; });
                var customInsertedEmails = _this.model[key]
                    ? _this.model[key].filter(function (email) { return !phonebookEmails_1.includes(email); })
                    : [];
                var newData = tslib_1.__spread(res, customInsertedEmails);
                _this.model = tslib_1.__assign({}, _this.model, (_a = {}, _a[key] = newData, _a));
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    return AddCommunicationDialogComponent;
}());
export { AddCommunicationDialogComponent };
